<script>
import appConfig from "@/app.config";
export default {
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      publicData: {},
      footerData: {},
      menuData: [],
      englishSocial: [
        "fb-icon.svg",
        "twiter-icon.svg",
        "insta-icon.svg",
        "youtube-icon.svg",
      ],
      chineseSocial: [
        "ch-social-icon1.svg",
        "ch-social-icon2.svg",
        "ch-social-icon3.svg",
        "ch-social-icon4.svg",
      ],
    };
  },
  methods: {
    languageChanged(value) {
      this.footerData = this.publicData.data[value].footerData;
      if (value === "en") {
        this.menuData.push(this.footerData.facebook);
        this.menuData.push(this.footerData.twitter);
        this.menuData.push(this.footerData.instagram);
        this.menuData.push(this.footerData.youtube);
      } else {
        this.menuData = [];
      }
    },
    openDetailModal(social) {
      if (this.$i18n.locale == "zh" && social == "ch-social-icon1.svg") {
        this.$bvModal.show("weChat-qrcode-modal");
      }
    },
  },
  created: function () {
    this.GLOBAL.addEventListener("languageChanged", this.languageChanged);
    this.publicData = window.publicData;
  },
};
</script>
<template>
  <div :class="$style.socialLink" class="w-100">
    <!-- <div class="flex-row d-flex align-items-center justify-content-between">
      <div
        v-for="(social, index) in $i18n.locale === 'en'
          ? englishSocial
          : chineseSocial"
        :key="index"
      >
        <a :href="menuData[index]" target="_blank">
          <img :src="assetsPath + 'images/icons/' + social" alt="" />
        </a>
      </div>
    </div> -->
  </div>
</template>
<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";
.socialLink {
  margin-top: 40px;
  a {
    transition: 0.3s;
  }
  a:hover {
    opacity: 0.9;
    transform: scale(1.1);
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .socialLink {
    img {
      width: 45px;
    }
  }
}
@media only screen and (max-width: 350px) {
  .socialLink {
    img {
      width: 50px;
    }
  }
}
</style>
